import React, { useState, useEffect } from 'react'
import Classes from './Appointments.module.css'
import RecordTable from '../Dashboard/Comp/RecordTable/RecordTable';
import { useSelector } from 'react-redux';
import backend from '../../../../../api';

export default function Appointments() {
    const {user} = useSelector((s) => s?.auth || {});

    const userId = user?._id;


//       // CANCEL/REFUND booking
//   const doRefund = async () => {
//     try {
//       const stripeAccountId = booking?.stripeAccountId;
//       const paymentIntentId = booking?.paymentIntentId;
//       const amount = booking?.bookingFee || 0;
//       const platformFee = booking?.platformFee || 0;

//       if (booking.status?.label == 'Canceled') {
//         enqueueSnackbar('This booking is already Canceled.', { variant: 'error' });
//         closeConfirm();
//         return;
//       }

//       if (amount <= 0) {
//         enqueueSnackbar('Invalid refund amount.', { variant: 'error' });
//         closeConfirm();
//         return;
//       }
//       if (booking?.status === 'Refunded') {
//         enqueueSnackbar('This booking is already refunded.', { variant: 'error' });
//         closeConfirm();
//         return;
//       }

//       setLoading(true);
//       const resp = await backend.post('/pay/refund', {
//         stripeAccountId,
//         paymentIntentId,
//         amount,
//         platformFee,
//         bookingId,
//       });

//       if (resp.status === 200) {
//         enqueueSnackbar('Cancel request initiated successfully.', { variant: 'success' });
//         setDropDown(false);
//         window.location.reload();
//       } else {
//         enqueueSnackbar('Refund failed: ' + (resp.data?.error || 'Unknown error'), { variant: 'error' });
//       }
//     } catch (err) {
//       console.error('Error processing refund:', err);
//       enqueueSnackbar('Error processing refund: ' + (err.response?.data?.error || err.message), {
//         variant: 'error',
//       });
//     } finally {
//       setLoading(false);
//       closeConfirm();
//     }
//   };

//   const handleReschedule = () => {
//     if (booking?.status?.label === 'Canceled') {
//       enqueueSnackbar('Not allowed for canceled bookings', { variant: 'error' });
//     } else {
//       setRescheduleOpen(true);
//     }
//   };

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <div>
                    <h3 className={Classes.title3} >Appointments</h3>
                    <h5 className={Classes.text} >Review your upcoming and past meetings.</h5>
                </div>
                <div>
                    <div className={Classes.searcCon}>
                        <img src="/assets/images/search.png" alt="icon" />
                        <input type="text" placeholder="Search..." />
                    </div>
                </div>
            </div>

            <RecordTable />
        </div>
    )
}
